import React, { useMemo } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useCallback } from "react";

import usePageAttachmentTabs from "../../Hooks/usePageAttachmentTabs";
// import NewTabs from "../new-client-dashboard/NewTabs";
import addIconGold from "../../assets/Add-icon-gold.svg";
import SmartResponsiveTabsContainer from "../DefendantPage/DefandantMain/components/ResponsiveTabDefendants";
import PageDocsTab, { createDocsTab } from "../DocPage/new-tab/page-docs-tab";
import { getCaseId, getClientId } from "../../Utils/helper";

// import CustomTab from "./CustomTab";
import CostTable, { RenderAdditionalRows } from "./CostTable";
import { useCostManagement } from "./CostManagementContext";
import EditEnvelopeCostModal from "./EditEnvelopeCostModal";
// import TreatmentTabs from "../TreatmentPage/TreatmentTabs";

const PageContent = ({
  currentPage,
  onEditCost,
  slotDetails,
  costs,
  openCosts,
  requestedCosts,
  paidCosts,
  creditCardCosts,
}) => {
  switch (currentPage) {
    // Employment MainTab use it for previous work
    case "all":
      return <CostTable onEditCost={onEditCost} costs={costs} slotDetails={slotDetails} />;
    case "open":
      return <CostTable onEditCost={onEditCost} costs={openCosts} slotDetails={slotDetails} />;
    case "requested":
      return <CostTable onEditCost={onEditCost} costs={requestedCosts} slotDetails={slotDetails} />;
    case "paid":
      return <CostTable onEditCost={onEditCost} costs={paidCosts} slotDetails={slotDetails} />;
    case "creditCard":
      return (
        <CostTable onEditCost={onEditCost} costs={creditCardCosts} slotDetails={slotDetails} />
      );
    default:
      return null;
  }
};

const CostTabs = ({
  pageObject,
  costs,
  openCosts,
  requestedCosts,
  paidCosts,
  creditCardCosts,
  slotDetails,
  envelopeCostState,
  onUpdate,
  onEditCost = () => {},
  loading,
}) => {
  const [showEnvelopeModal, setShowEnvelopeModal] = useState(false);

  const handleEditEnvelope = () => {
    setShowEnvelopeModal(true);
  };
  const onHide = useCallback(() => setShowEnvelopeModal(false), []);
  const [envelopeCost, setEnvelopeCost] = envelopeCostState;
  const [currentPage, setCurrentPage] = useState("all");
  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);
  const docsTabs = useMemo(
    () => [createDocsTab(() => handlePageChange("docs"))],
    [handlePageChange]
  );
  const attachmentTabs = usePageAttachmentTabs(16, docsTabs);

  const mainTabs = useMemo(
    () => [
      {
        id: "all",
        label: "All",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        onClick: () => handlePageChange("all"),
        leftHand: false,
      },
      {
        id: "open",
        label: "Open",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        onClick: () => handlePageChange("open"),
        leftHand: false,
      },
      {
        id: "requested",
        label: "Requested",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        onClick: () => handlePageChange("requested"),
        leftHand: false,
      },
      {
        id: "paid",
        label: "Paid",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        onClick: () => handlePageChange("paid"),
        leftHand: false,
      },
      // {
      //   id: "creditCard",
      //   label: "Credit Card",
      //   className: "tab-trapezium-cycles-corners",
      //   background: "var(--primary-60)",
      //   activeColor: "white",
      //   onClick: () => handlePageChange("creditCard"),
      //   leftHand: false,
      // },
    ],
    [handlePageChange]
  );
  const { showModal } = useCostManagement();
  const actionTabs = useMemo(
    () => [
      {
        id: "add-cost",
        label: "Add Cost",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        left: "0px",
        onClick: () => showModal({}, false),
        leftHand: true,
        span: (
          <span className="fw-bold  ic-15 d-flex align-items-center">
            <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
          </span>
        ),
      },
      {
        id: "edit-cost-envelope",
        label: "Edit Cost Envelope",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        left: "0px",
        onClick: () => handleEditEnvelope(),
        leftHand: true,
        span: (
          <span className="fw-bold  ic-15 d-flex align-items-center">
            <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
          </span>
        ),
      },
    ],
    []
  );

  const adjustReportColumnWidths = () => {
    const pinColumn = (selector) => {
      const cols = document.querySelectorAll(selector);
      if (!cols.length) return;
      let maxWidth = 0;
      cols.forEach((col) => {
        maxWidth = Math.max(maxWidth, col.getBoundingClientRect().width);
      });
      cols.forEach((col) => {
        col.style.width = `${maxWidth}px`;
        col.style.minWidth = `${maxWidth}px`;
        col.style.maxWidth = `${maxWidth}px`;
      });
    };

    pinColumn(".requested-col");
    pinColumn(".payee-col");
    pinColumn(".memo-col");
    pinColumn(".note-col");
    pinColumn(".invoice-col");
    pinColumn(".account-col");
    pinColumn(".amount-col");
    pinColumn(".payment-col");
  };

  useEffect(() => {
    adjustReportColumnWidths();
    window.addEventListener("resize", adjustReportColumnWidths);
    return () => window.removeEventListener("resize", adjustReportColumnWidths);
  }, [costs]);
  return (
    <>
      {envelopeCost?.amount && (
        <EditEnvelopeCostModal
          show={showEnvelopeModal}
          envelopeCost={envelopeCost}
          onHide={onHide}
          onUpdate={(updatedCost) => {
            setEnvelopeCost(updatedCost);
            if (onUpdate) {
              onUpdate(updatedCost);
            }
          }}
        />
      )}

      <div
        className="card col-lg-12"
        style={{
          border: "none",
          padding: 0,
          margin: 0,
        }}
      >
        <SmartResponsiveTabsContainer
          HandlePage={currentPage}
          tabsData={mainTabs}
          viewTab={actionTabs}
          addTab={[]}
          photoTab={attachmentTabs}
          photoTabControlled={true}
          handlePageChange={handlePageChange}
          viewType={""}
        />
        <div className="tab-content" id="nav-tabContent">
          {currentPage === "docs" ? (
            <PageDocsTab
              key={`${getClientId()}-${getCaseId()}`}
              pageId={16}
              pageName={pageObject?.name}
              pageIcon={pageObject?.page_icon}
            />
          ) : loading ? (
            <RenderAdditionalRows additionalRows={8} />
          ) : (
            <PageContent
              currentPage={currentPage}
              onEditCost={onEditCost}
              slotDetails={slotDetails}
              costs={costs}
              openCosts={openCosts}
              requestedCosts={requestedCosts}
              paidCosts={paidCosts}
              creditCardCosts={creditCardCosts}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default React.memo(CostTabs);
